import { updateVatSettings } from "@/api/settings/take-order-settings";
import { serviceChargeSettingsApi } from "@/api/take-order/take-order";
import { Switch } from "@/components/ui/switch";
import { TabsContent } from "@/components/ui/tabs";
import useAuth from "@/hooks/useAuth";
import useSettings from "@/hooks/useSettings";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

function ServiceChargeTab(){
    const [serviceCharge, setServiceCharge] = useState(false);
    const [chargeAmount, setChargeAmount] = useState(0);
    const { user } = useAuth();
    const {settings, status} = useSettings();


console.log("service charge settings tab rendered");

    useEffect(()=>{

        console.log("settings changed", settings)

        if(settings && status == true && settings.take_order && settings.take_order.service_charge_setting !== undefined){
            setServiceCharge(settings.take_order.service_charge_setting.is_service_charge_enabled);
            setChargeAmount(settings.take_order.service_charge_setting.amount || 0);
        }
    }, []);

    function handleSave(status){
        
        console.log("saving service charge settings", status, chargeAmount);
        serviceChargeSettingsApi(user?.restaurant_id, {
            is_service_charge_enabled: status,
            amount: Number(chargeAmount)
        }).then((res) => {
            console.log(res);
            if(res.status === "success"){
                toast.success("Service Charge settings saved!");

                localStorage.setItem("settings", JSON.stringify({
                    ...JSON.parse(localStorage.getItem("settings") || "{}"),
                    take_order: {
                    ...JSON.parse(localStorage.getItem("settings") || "{}").take_order,
                    service_charge_setting: res?.data?.service_charge_setting,
                    },
                }));

            }
            else{
                toast.error(res.message || "Failed to save Service Charge settings.");
            }
            
        }); 
    }


    return(
        <TabsContent value="service-charge" className="w-full">
            <div className=" w-full p-2">
                <div className=" w-full p-2 bg-color2 text-color5 flex items-center justify-between">
                    <span>Service Charge</span>
                    <Switch checked={serviceCharge} onCheckedChange={(e)=>{ setServiceCharge(e); handleSave(e);}}/>
                </div>
                {serviceCharge && (
                    <div className=" w-full p-2 bg-color2 mt-4 flex flex-col items-end gap-4">
                        <div className=" w-full flex items-center justify-between"> 
                            <span className=" text-color5" htmlFor="charge-amount">Charge Amount</span>
                            <input
                                type="number"
                                id="charge-amount"
                                value={chargeAmount}
                                onChange={(e) => setChargeAmount(e.target.value)}
                                className=" border border-color4 rounded px-2 py-1 w-32 bg-color3 text-color5"
                            />
                        </div>
                        <button onClick={() => handleSave(serviceCharge)} className=" py-1 px-4 bg-color7 text-color5 rounded-md" >Save</button>
                    </div>
                )}
            </div>
        </TabsContent>
    )
}

export default ServiceChargeTab;